import axios from '../getAxios';
import { loginPayloadProps } from '../types';

export default async (payload: loginPayloadProps) => {

  const { data } = await axios({
    method: 'POST',
    url: '/api/customer/login',
    data: payload,
  });
  return data;
};